module.exports = __webpack_public_path__ + "img/Gunnar-Ploehn-860.bd579287.jpg";